<template>
  <div>

    <div class="box" :class="{ 'pl-0 pr-0': compact }">

      <div class="flex flex-wrap items-center" v-if="showActions">
        <div class="flex-grow mb-1">
          <list-search v-model="searchInput" @search="getReminderLists"/>
          <p class="text-xs mt-0 ml-1" v-if="query.search !== ''">
            Searching for <span class="text-red-500 font-bold">{{ query.search }}</span>
          </p>
        </div>

        <div class="flex">
          <div
            v-if="hasPermission('reminder-list.create')"
            class="btn btn-purple text-sm mr-2 h-10 flex items-center px-3 mb-1"
            @click="$router.push('/reminder-list/create/')"
          >
            <i class="fas fa-plus"></i>
            <span class="ml-2">New reminder list</span>
          </div>

          <button class="btn w-10 h-10 flex items-center justify-center focus:outline-none hover:text-green-500 mb-1" @click="getReminderLists">
            <i class="fas fa-sync-alt"></i>
          </button>
        </div>
      </div>


      <p class="text-lg text-center my-12" v-if="!hasReminderLists">No data to display</p>
      <div class="w-full overflow-x-auto" v-else>
        <table class="table table-striped">
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Recipient count</th>
              <th>Created at</th>
              <th>Used</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(list, i) in reminderLists" :key="i">
              <td class="font-bold">{{ list.id }}</td>
              <td>{{ list.name }}</td>
              <td>{{ list.recipients ? list.recipients.length : 0 }}</td>
              <td>
                {{ $moment(list.created_at).format(config.dateTimeFormats.display) }}
              </td>
              <td>{{ list.reminders ? list.reminders.length : 0 }}</td>
              <td>
                <a
                  v-if="hasPermission('reminder-list.edit')"
                  class="hover:text-theme-darker text-base cursor-pointer p-2"
                  @click.stop="$router.push('/reminder-list/edit/' + list.id)"
                ><i class="fas fa-edit"></i></a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="w-full flex justify-center">
        <pagination-component
          class="mt-8"
          v-if="hasReminderLists && pagination.totalRows / pagination.perPage > 1"
          v-model="pagination.currentPage"
          :total-rows="pagination.totalRows"
          :rows-per-page="pagination.perPage"
        />
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
const ListSearch = resolve => require(['@/components/ListSearch'], resolve)
const PaginationComponent = resolve => require(['@/components/Pagination'], resolve)

export default {
  props: {
    customerID: {},
    showActions: {
      type: Boolean,
      default: true,
    },
    method: String,
    compact: Boolean,
  },
  components: {
    ListSearch,
    PaginationComponent,
  },
  data() {
    return {
      reminderLists: [],
      searchInput: '',
      query: {
        search: '',
      },
      pagination: {
        currentPage: 1,
        totalRows: 0,
        perPage: 0,
      }
    }
  },
  watch: {
    'pagination.currentPage'() {
      this.getReminderLists()
    },
    searchInput(i) {
      if (i === '' && this.query.search !== '') {
        this.getReminderLists()
      }
    },
  },
  computed: {
    hasReminderLists() {
      return Object.entries(this.reminderLists).length > 0
    },
    ...mapGetters({
      config: 'config/config',
      hasPermission: 'user/hasPermission',
    })
  },
  mounted() {
    this.getReminderLists()
  },
  methods: {
    getReminderLists() {
      axios.get('reminder-lists', {params: {
        page: this.pagination.currentPage,
        search: this.searchInput,
      }})
        .then(response => {
          if (response.data) {
            const res = response.data
            this.pagination.perPage = res.per_page
            this.pagination.totalRows = res.total
            this.reminderLists = Object.assign([], res.data)

            this.query.search = this.searchInput
          }
        })
    }
  }
}
</script>
